import React, { useEffect, useState } from 'lib/react';
import {
  EVGrid,
} from 'lib/components';
import { useSelector, useDispatch } from 'lib/redux';
import Map from 'commonComponents/map';
import PropTypes from 'prop-types';
import {
  COMMERCIAL, RESIDENTIAL,
  FOCUSED_PIN_COLORS,
  PIN_COLORS,
} from 'constants/AppConstants';
import { loadReportAddresses } from 'features/reportDetails/ReportDetailsPage.actions';
import { isEntitledForEmbeddedExplorerSelector } from 'utils/appSelectors.utils';
import ReportDetailsMapStyles from './ReportDetailsMapStyles';

function ReportDetailsMap({ pinIndex, orderId, useEmbeddedExplorer }) {
  const dispatch = useDispatch();
  const classes = ReportDetailsMapStyles();

  const mapPoints = useSelector((state) => state.reportDetailsPage.reportAddresses);
  const isReportMSO = useSelector((state) => state.orderHistory.reportDetails[0].isReportMSO);

  const [focusedPointIndex, setFocusedPointIndex] = useState(null);

  const isEntitledForEmbeddedExplorer = useSelector(isEntitledForEmbeddedExplorerSelector);

  const [currentColors, setCurrentColors] = useState([...FOCUSED_PIN_COLORS]);
  const setPinColors = () => {
    setCurrentColors(FOCUSED_PIN_COLORS);
    currentColors[pinIndex] = PIN_COLORS[pinIndex];
    setCurrentColors(currentColors);
  };

  const fetchReportsAddressesData = () => dispatch(loadReportAddresses(Number(orderId)));
  useEffect(() => { fetchReportsAddressesData(); setPinColors(); }, [pinIndex]);

  const propertyType = isReportMSO ? COMMERCIAL : RESIDENTIAL;
  const handleFocusChange = (index) => setFocusedPointIndex(index === focusedPointIndex ? null : index);

  return (
    <EVGrid className={classes.mapContainer}>
      {mapPoints.length && (
        <Map
          useEmbeddedExplorer={isEntitledForEmbeddedExplorer && useEmbeddedExplorer}
          center={mapPoints[pinIndex]?.address}
          mapPoints={mapPoints}
          isComplex={isReportMSO}
          propertyType={propertyType}
          focusedPinIndex={focusedPointIndex}
          onFocusChange={handleFocusChange}
          mapOptions={{ showMapTypeSelector: false, showScalebar: false }}
          colors={currentColors}
        />
      )}
    </EVGrid>
  );
}

ReportDetailsMap.propTypes = {
  pinIndex: PropTypes.number.isRequired,
  orderId: PropTypes.number.isRequired,
  useEmbeddedExplorer: PropTypes.bool.isRequired,
};

export default ReportDetailsMap;
